export default "__VITE_ASSET__C$K_xtl3__"